import type { AmendmentValues, ContractValues } from "../schemas/contract";
import type { Contract, ContractAmendmentInput, ContractInput } from "../types";
import { normalizeAmount } from "@frontend/utils/amount";

function blankToNull(value: string | null): string | null {
  return null === value || "" === value.trim() ? null : value;
}

export function toContractInput(values: ContractValues): ContractInput {
  return {
    lockVersion: values.lockVersion,
    dateBegin: values.dateBegin,
    dateEnd: values.dateEnd,
    contractGroupId: values.contractGroupId,
    contractDurationId: values.contractDurationId,
    endDelayId: values.endDelayId,
    billPeriodId: values.billPeriodId,
    postPeriodBilling: values.postPeriodBilling,
    autoRenewal: values.autoRenewal,
    renewalWarning: values.renewalWarning,
    workedWeeksCount: values.workedWeeksCount,
    terminationReasonId: values.terminationReasonId,
    price: normalizeAmount(values.price),
    priceType: values.priceType,
    amendments: values.amendments.map(toAmendmentInput),
    commercialCondition: {
      subscriptionPaymentPeriodId:
        values.commercialCondition.subscriptionPaymentPeriodId,
      paymentTypeId: values.commercialCondition.paymentTypeId,
      paymentEmail: blankToNull(values.commercialCondition.paymentEmail),
      paymentTargetId: values.commercialCondition.paymentTargetId,
      subscriptionBillingTimeId:
        values.commercialCondition.subscriptionBillingTimeId,
      priceRevisionActivation:
        values.commercialCondition.priceRevisionActivation,
    },
  };
}

function toAmendmentInput(amendment: AmendmentValues): ContractAmendmentInput {
  return {
    id: amendment.id,
    dateBegin: amendment.dateBegin,
    price: normalizeAmount(amendment.price),
    comments: blankToNull(amendment.comments),
  };
}

export function toContractValues(contract: Contract): ContractValues {
  return {
    lockVersion: contract.lockVersion,
    dateBegin: contract.dateBegin,
    dateEnd: contract.dateEnd,
    contractGroupId: contract.contractGroupId,
    contractDurationId: contract.contractDurationId,
    endDelayId: contract.endDelayId,
    billPeriodId: contract.billPeriodId,
    postPeriodBilling: contract.postPeriodBilling,
    autoRenewal: contract.autoRenewal,
    renewalWarning: contract.renewalWarning,
    workedWeeksCount: contract.workedWeeksCount,
    terminationReasonId: contract.terminationReasonId,
    price: contract.price,
    priceType: contract.priceType,
    amendments: contract.amendments.map((amendment) => ({
      id: amendment.id,
      dateBegin: amendment.dateBegin,
      price: amendment.price,
      comments: amendment.comments,
      deletable: amendment.deletable,
    })),
    commercialCondition: {
      subscriptionPaymentPeriodId:
        contract.commercialCondition?.subscriptionPaymentPeriodId ?? null,
      paymentTypeId: contract.commercialCondition?.paymentTypeId ?? null,
      paymentEmail: contract.commercialCondition?.paymentEmail ?? null,
      paymentTargetId: contract.commercialCondition?.paymentTargetId ?? null,
      subscriptionBillingTimeId:
        contract.commercialCondition?.subscriptionBillingTimeId ?? null,
      priceRevisionActivation:
        contract.commercialCondition?.priceRevisionActivation ?? true,
    },
  };
}
